import { uploadUser } from "../Firebase";
import { updateOrgTreeWithNewUserRoles } from "./OrgTreeFunctions";

export const alreadyCheckedCombinations: {
  isTheSameName: boolean;
  nameOne: string;
  nameTwo: string;
}[] = [
  {
    nameOne: "Elly",
    nameTwo: "Tim",
    isTheSameName: false,
  },
  {
    nameOne: "Elly",
    nameTwo: "Michelle",
    isTheSameName: false,
  },
  {
    nameOne: "Tim",
    nameTwo: "Michelle",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Michael",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Bull",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Ewikowski",
    isTheSameName: false,
  },
  {
    nameOne: "Barker",
    nameTwo: "Kohring",
    isTheSameName: false,
  },
  {
    nameOne: "Beale",
    nameTwo: "February",
    isTheSameName: false,
  },
  {
    nameOne: "Joey",
    nameTwo: "Adriana",
    isTheSameName: false,
  },
  {
    nameOne: "Bognar",
    nameTwo: "Preece",
    isTheSameName: false,
  },
  {
    nameOne: "Allan",
    nameTwo: "Wendy",
    isTheSameName: false,
  },
  {
    nameOne: "Brown",
    nameTwo: "Kelly",
    isTheSameName: false,
  },
  {
    nameOne: "Bull",
    nameTwo: "Ewikowski",
    isTheSameName: false,
  },
  {
    nameOne: "Bunn",
    nameTwo: "Were",
    isTheSameName: false,
  },
  {
    nameOne: "Cherie",
    nameTwo: "Ben",
    isTheSameName: false,
  },
  {
    nameOne: "Burns",
    nameTwo: "Dunn",
    isTheSameName: false,
  },
  {
    nameOne: "Burns",
    nameTwo: "Jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "Sandy",
    nameTwo: "Peter",
    isTheSameName: false,
  },
  {
    nameOne: "Crafts",
    nameTwo: "Edwards",
    isTheSameName: false,
  },
  {
    nameOne: "Crafts",
    nameTwo: "Hoare",
    isTheSameName: false,
  },
  {
    nameOne: "Cronin",
    nameTwo: "Lengkong",
    isTheSameName: false,
  },
  {
    nameOne: "Cronin",
    nameTwo: "Randell",
    isTheSameName: false,
  },
  {
    nameOne: "Crouch",
    nameTwo: "Glenister",
    isTheSameName: false,
  },
  {
    nameOne: "Lorene",
    nameTwo: "Louis",
    isTheSameName: false,
  },
  {
    nameOne: "Cvetanovic",
    nameTwo: "Hunt",
    isTheSameName: false,
  },
  {
    nameOne: "Damianopoulos",
    nameTwo: "Smith",
    isTheSameName: false,
  },
  {
    nameOne: "Kmy",
    nameTwo: "Jonathan",
    isTheSameName: false,
  },
  {
    nameOne: "Di mauro",
    nameTwo: "Thomas",
    isTheSameName: false,
  },
  {
    nameOne: "Ben",
    nameTwo: "Cara",
    isTheSameName: false,
  },
  {
    nameOne: "Dunn",
    nameTwo: "Jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "David",
    nameTwo: "Deanne",
    isTheSameName: false,
  },
  {
    nameOne: "Edwards",
    nameTwo: "Hoare",
    isTheSameName: false,
  },
  {
    nameOne: "Michelle",
    nameTwo: "Manfred",
    isTheSameName: false,
  },
  {
    nameOne: "Dwayne",
    nameTwo: "Celeste",
    isTheSameName: false,
  },
  {
    nameOne: "Nick",
    nameTwo: "Val",
    isTheSameName: false,
  },
  {
    nameOne: "Hilton",
    nameTwo: "Liesl",
    isTheSameName: false,
  },
  {
    nameOne: "Hilton",
    nameTwo: "Nicky",
    isTheSameName: false,
  },
  {
    nameOne: "Liesl",
    nameTwo: "Nicky",
    isTheSameName: false,
  },
  {
    nameOne: "Stephen",
    nameTwo: "Kathryn",
    isTheSameName: false,
  },
  {
    nameOne: "Foster",
    nameTwo: "Ram",
    isTheSameName: false,
  },
  {
    nameOne: "Goode",
    nameTwo: "Lindley",
    isTheSameName: false,
  },
  {
    nameOne: "Gunek",
    nameTwo: "Manansang",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Moore",
    isTheSameName: false,
  },
  {
    nameOne: "Hollands",
    nameTwo: "Orr",
    isTheSameName: false,
  },
  {
    nameOne: "Ben",
    nameTwo: "Bec",
    isTheSameName: false,
  },
  {
    nameOne: "Jarvis",
    nameTwo: "Wood",
    isTheSameName: false,
  },
  {
    nameOne: "Rebecca",
    nameTwo: "Matthew",
    isTheSameName: false,
  },
  {
    nameOne: "Jones",
    nameTwo: "Tinker",
    isTheSameName: false,
  },
  {
    nameOne: "Denise",
    nameTwo: "Lauren",
    isTheSameName: false,
  },
  {
    nameOne: "Denise",
    nameTwo: "Daniel",
    isTheSameName: false,
  },
  {
    nameOne: "Lauren",
    nameTwo: "Daniel",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Koblischke",
    isTheSameName: false,
  },
  {
    nameOne: "Lengkong",
    nameTwo: "Randell",
    isTheSameName: false,
  },
  {
    nameOne: "Jane",
    nameTwo: "Leonard",
    isTheSameName: false,
  },
  {
    nameOne: "Lewis",
    nameTwo: "Willis",
    isTheSameName: false,
  },
  {
    nameOne: "Mcaulay",
    nameTwo: "Mcdonnell",
    isTheSameName: false,
  },
  {
    nameOne: "Mcaulay",
    nameTwo: "Parker",
    isTheSameName: false,
  },
  {
    nameOne: "Mcdonnell",
    nameTwo: "Parker",
    isTheSameName: false,
  },
  {
    nameOne: "Sally",
    nameTwo: "Rose",
    isTheSameName: false,
  },
  {
    nameOne: "Naidoo",
    nameTwo: "Soh",
    isTheSameName: false,
  },
  {
    nameOne: "Eddie",
    nameTwo: "Rachael",
    isTheSameName: false,
  },
  {
    nameOne: "Kathryn",
    nameTwo: "Nigel",
    isTheSameName: false,
  },
  {
    nameOne: "Jacinda",
    nameTwo: "Benjamin",
    isTheSameName: false,
  },
  {
    nameOne: "Julie",
    nameTwo: "Terry",
    isTheSameName: false,
  },
  {
    nameOne: "Alana",
    nameTwo: "Elli",
    isTheSameName: false,
  },
  {
    nameOne: "Alana",
    nameTwo: "Artie",
    isTheSameName: false,
  },
  {
    nameOne: "Elli",
    nameTwo: "Artie",
    isTheSameName: false,
  },
  {
    nameOne: "Karen",
    nameTwo: "Amber",
    isTheSameName: false,
  },
  {
    nameOne: "Rob",
    nameTwo: "Amanda",
    isTheSameName: false,
  },
  {
    nameOne: "Janet",
    nameTwo: "Kylie",
    isTheSameName: false,
  },
  {
    nameOne: "Robyn",
    nameTwo: "Noel",
    isTheSameName: false,
  },
  {
    nameOne: "Maureen",
    nameTwo: "Marty",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Felton ",
    isTheSameName: true,
  },
  {
    nameOne: "Felton",
    nameTwo: "Felt9n",
    isTheSameName: true,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Moore ",
    isTheSameName: false,
  },
  {
    nameOne: "Jones",
    nameTwo: "Jones",
    isTheSameName: true,
  },
  {
    nameOne: "Lex",
    nameTwo: "Lex ",
    isTheSameName: true,
  },
  {
    nameOne: "Moore",
    nameTwo: "Moore ",
    isTheSameName: true,
  },
  {
    nameOne: "Katie",
    nameTwo: "Katie ",
    isTheSameName: true,
  },
  {
    nameOne: "Mcelrea ",
    nameTwo: "Mcelrea ",
    isTheSameName: true,
  },
  {
    nameOne: "Clancy",
    nameTwo: "Clancy",
    isTheSameName: true,
  },
  {
    nameOne: "Mcelrea",
    nameTwo: "Mcelrea",
    isTheSameName: true,
  },
  {
    nameOne: "Moore",
    nameTwo: "Moore",
    isTheSameName: true,
  },
  {
    nameOne: "Randell",
    nameTwo: "Randell",
    isTheSameName: true,
  },
  {
    nameOne: "Aghajanian",
    nameTwo: "Aghjanian",
    isTheSameName: true,
  },
  {
    nameOne: "Alder",
    nameTwo: "Aldee",
    isTheSameName: true,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Elly",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Hagenaar",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Fergusson",
    isTheSameName: false,
  },
  {
    nameOne: "Audrey",
    nameTwo: "Audrey`",
    isTheSameName: true,
  },
  {
    nameOne: "Barry",
    nameTwo: "Smith",
    isTheSameName: false,
  },
  {
    nameOne: "Benn",
    nameTwo: "Benn (wednesday)",
    isTheSameName: true,
  },
  {
    nameOne: "Betham",
    nameTwo: "Lala",
    isTheSameName: false,
  },
  {
    nameOne: "Brinsden",
    nameTwo: "Brinsde",
    isTheSameName: true,
  },
  {
    nameOne: "Brinsden",
    nameTwo: "Gek",
    isTheSameName: false,
  },
  {
    nameOne: "Brinsden",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Brown",
    nameTwo: "Rown",
    isTheSameName: true,
  },
  {
    nameOne: "Bull",
    nameTwo: "Fergusson",
    isTheSameName: false,
  },
  {
    nameOne: "Bunn",
    nameTwo: "Taylor",
    isTheSameName: false,
  },
  {
    nameOne: "Burns",
    nameTwo: "Little",
    isTheSameName: false,
  },
  {
    nameOne: "Kenelm",
    nameTwo: "Eugenie",
    isTheSameName: false,
  },
  {
    nameOne: "Kenelm",
    nameTwo: "Joel",
    isTheSameName: false,
  },
  {
    nameOne: "Clancy",
    nameTwo: "Hinchlidde",
    isTheSameName: false,
  },
  {
    nameOne: "Clancy",
    nameTwo: "Hinchliffe",
    isTheSameName: false,
  },
  {
    nameOne: "Clancy",
    nameTwo: "Cunningham",
    isTheSameName: false,
  },
  {
    nameOne: "Coleman",
    nameTwo: "Cokeman",
    isTheSameName: true,
  },
  {
    nameOne: "Janie",
    nameTwo: "Jamie",
    isTheSameName: true,
  },
  {
    nameOne: "David",
    nameTwo: "Dave",
    isTheSameName: true,
  },
  {
    nameOne: "Crafts",
    nameTwo: "Edwards (wednesday 10th)",
    isTheSameName: false,
  },
  {
    nameOne: "Crafts",
    nameTwo: "Jurgensen",
    isTheSameName: false,
  },
  {
    nameOne: "Cronin",
    nameTwo: "Glass",
    isTheSameName: false,
  },
  {
    nameOne: "Crouch",
    nameTwo: "Chee",
    isTheSameName: false,
  },
  {
    nameOne: "Crouch",
    nameTwo: "Mclean",
    isTheSameName: false,
  },
  {
    nameOne: "Crouch",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Suzy",
    nameTwo: "Joshua",
    isTheSameName: false,
  },
  {
    nameOne: "Cutmore",
    nameTwo: "Cutmroe",
    isTheSameName: true,
  },
  {
    nameOne: "Damianopoulos",
    nameTwo: "Damianopolous",
    isTheSameName: true,
  },
  {
    nameOne: "Damianopoulos",
    nameTwo: "Triggs",
    isTheSameName: false,
  },
  {
    nameOne: "Deng",
    nameTwo: "Yam",
    isTheSameName: false,
  },
  {
    nameOne: "Dixon",
    nameTwo: "Dixo",
    isTheSameName: true,
  },
  {
    nameOne: "Dunn",
    nameTwo: "Little",
    isTheSameName: false,
  },
  {
    nameOne: "Ben",
    nameTwo: "Benjamin",
    isTheSameName: true,
  },
  {
    nameOne: "Edwards",
    nameTwo: "Jurgensen",
    isTheSameName: false,
  },
  {
    nameOne: "David",
    nameTwo: "Deborah",
    isTheSameName: false,
  },
  {
    nameOne: "David",
    nameTwo: "Hannah",
    isTheSameName: false,
  },
  {
    nameOne: "David",
    nameTwo: "Lily",
    isTheSameName: false,
  },
  {
    nameOne: "Deanne",
    nameTwo: "Deborah",
    isTheSameName: false,
  },
  {
    nameOne: "Deanne",
    nameTwo: "Hannah",
    isTheSameName: false,
  },
  {
    nameOne: "Deanne",
    nameTwo: "Lily",
    isTheSameName: false,
  },
  {
    nameOne: "Ewikowski",
    nameTwo: "Fergusson",
    isTheSameName: false,
  },
  {
    nameOne: "Feebrey",
    nameTwo: "Chan",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Khiroya",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Rough",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Field",
    nameTwo: "Mcglone",
    isTheSameName: false,
  },
  {
    nameOne: "Field",
    nameTwo: "Mcglones",
    isTheSameName: false,
  },
  {
    nameOne: "Field",
    nameTwo: "Wyborn",
    isTheSameName: false,
  },
  {
    nameOne: "Foong",
    nameTwo: "Lawler",
    isTheSameName: false,
  },
  {
    nameOne: "Foster",
    nameTwo: "Refalo",
    isTheSameName: false,
  },
  {
    nameOne: "Alisya",
    nameTwo: "Katie",
    isTheSameName: false,
  },
  {
    nameOne: "Alisya",
    nameTwo: "Katoe",
    isTheSameName: false,
  },
  {
    nameOne: "Glenister",
    nameTwo: "Chee",
    isTheSameName: false,
  },
  {
    nameOne: "Glenister",
    nameTwo: "Mclean",
    isTheSameName: false,
  },
  {
    nameOne: "Glenister",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Serge",
    nameTwo: "Sege",
    isTheSameName: true,
  },
  {
    nameOne: "Gunek",
    nameTwo: "Skewes",
    isTheSameName: false,
  },
  {
    nameOne: "Kerith",
    nameTwo: "Tim",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Cawthorn",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: true,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: true,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Sapuppo",
    isTheSameName: false,
  },
  {
    nameOne: "Hoare",
    nameTwo: "Edwards (wednesday 10th)",
    isTheSameName: false,
  },
  {
    nameOne: "Hoare",
    nameTwo: "Jurgensen",
    isTheSameName: false,
  },
  {
    nameOne: "Melanie",
    nameTwo: "Sue",
    isTheSameName: false,
  },
  {
    nameOne: "Anne",
    nameTwo: "Luke",
    isTheSameName: false,
  },
  {
    nameOne: "Jarvis",
    nameTwo: "Little",
    isTheSameName: false,
  },
  {
    nameOne: "Jarvis",
    nameTwo: "Jarvos",
    isTheSameName: true,
  },
  {
    nameOne: "Hannah",
    nameTwo: "Gavin",
    isTheSameName: false,
  },
  {
    nameOne: "Johnson",
    nameTwo: "Edwards",
    isTheSameName: false,
  },
  {
    nameOne: "Johnson",
    nameTwo: "Redman",
    isTheSameName: false,
  },
  {
    nameOne: "Rebecca",
    nameTwo: "Mat",
    isTheSameName: false,
  },
  {
    nameOne: "Rebecca",
    nameTwo: "Matt",
    isTheSameName: false,
  },
  {
    nameOne: "Jones",
    nameTwo: "Buckle",
    isTheSameName: false,
  },
  {
    nameOne: "Jones",
    nameTwo: "Rey",
    isTheSameName: false,
  },
  {
    nameOne: "Matthew",
    nameTwo: "Mat",
    isTheSameName: true,
  },
  {
    nameOne: "Denise",
    nameTwo: "Andrew",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Ackroyd",
    isTheSameName: true,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Kiernan",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Sckroyd",
    isTheSameName: false,
  },
  {
    nameOne: "Denise",
    nameTwo: "Leah",
    isTheSameName: false,
  },
  {
    nameOne: "Lauren",
    nameTwo: "Andrew",
    isTheSameName: false,
  },
  {
    nameOne: "Lauren",
    nameTwo: "Leah",
    isTheSameName: false,
  },
  {
    nameOne: "Daniel",
    nameTwo: "Andrew",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Cabrera",
    isTheSameName: false,
  },
  {
    nameOne: "Daniel",
    nameTwo: "Leah",
    isTheSameName: false,
  },
  {
    nameOne: "Kong",
    nameTwo: "Moosa",
    isTheSameName: false,
  },
  {
    nameOne: "Lalagavesi",
    nameTwo: "Lala",
    isTheSameName: true,
  },
  {
    nameOne: "Lammiman",
    nameTwo: "Lammimam",
    isTheSameName: true,
  },
  {
    nameOne: "Lengkong",
    nameTwo: "Glass",
    isTheSameName: false,
  },
  {
    nameOne: "Jane",
    nameTwo: "Jjane",
    isTheSameName: true,
  },
  {
    nameOne: "Lewis",
    nameTwo: "Steer",
    isTheSameName: false,
  },
  {
    nameOne: "Alan",
    nameTwo: "Akan",
    isTheSameName: true,
  },
  {
    nameOne: "Roberto",
    nameTwo: "Roby",
    isTheSameName: true,
  },
  {
    nameOne: "Lyon",
    nameTwo: "Lyom",
    isTheSameName: true,
  },
  {
    nameOne: "Manansang",
    nameTwo: "Skewes",
    isTheSameName: false,
  },
  {
    nameOne: "Sally",
    nameTwo: "Brian",
    isTheSameName: false,
  },
  {
    nameOne: "Rose",
    nameTwo: "Brian",
    isTheSameName: false,
  },
  {
    nameOne: "Drew",
    nameTwo: "Andrew",
    isTheSameName: true,
  },
  {
    nameOne: "Michael",
    nameTwo: "Hagenaar",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn 7th-13th",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Sapuppo",
    isTheSameName: false,
  },
  {
    nameOne: "Moss",
    nameTwo: "Martinez",
    isTheSameName: false,
  },
  {
    nameOne: "Amy",
    nameTwo: "Ameshri",
    isTheSameName: true,
  },
  {
    nameOne: "Naidoo",
    nameTwo: "Willcocks",
    isTheSameName: false,
  },
  {
    nameOne: "Gaye",
    nameTwo: "Bruce",
    isTheSameName: false,
  },
  {
    nameOne: "Pauline",
    nameTwo: "Isaac",
    isTheSameName: false,
  },
  {
    nameOne: "Robert",
    nameTwo: "Robby",
    isTheSameName: true,
  },
  {
    nameOne: "Robert",
    nameTwo: "Robwrt",
    isTheSameName: true,
  },
  {
    nameOne: "Portwin",
    nameTwo: "Perumal",
    isTheSameName: false,
  },
  {
    nameOne: "Portwin",
    nameTwo: "Reid",
    isTheSameName: false,
  },
  {
    nameOne: "Randell",
    nameTwo: "Glass",
    isTheSameName: false,
  },
  {
    nameOne: "Renae",
    nameTwo: "Amanda",
    isTheSameName: false,
  },
  {
    nameOne: "Rapana",
    nameTwo: "Rapana-jenkins",
    isTheSameName: true,
  },
  {
    nameOne: "Rkyek",
    nameTwo: "R'kyek",
    isTheSameName: true,
  },
  {
    nameOne: "Sangster",
    nameTwo: "Dunn (week ending 19th)",
    isTheSameName: false,
  },
  {
    nameOne: "Dunn",
    nameTwo: "Dunn (week ending 19th)",
    isTheSameName: true,
  },
  {
    nameOne: "Scott",
    nameTwo: "Scott wed",
    isTheSameName: true,
  },
  {
    nameOne: "Smith",
    nameTwo: "Smitg",
    isTheSameName: true,
  },
  {
    nameOne: "Karen",
    nameTwo: "Susan",
    isTheSameName: false,
  },
  {
    nameOne: "Amber",
    nameTwo: "Susan",
    isTheSameName: false,
  },
  {
    nameOne: "Soh",
    nameTwo: "Naid00",
    isTheSameName: false,
  },
  {
    nameOne: "Soh",
    nameTwo: "Willcocks",
    isTheSameName: false,
  },
  {
    nameOne: "Stanmore",
    nameTwo: "O",
    isTheSameName: false,
  },
  {
    nameOne: "Stanmore",
    nameTwo: "Rapana",
    isTheSameName: false,
  },
  {
    nameOne: "Sugunarajan",
    nameTwo: "Cunningham",
    isTheSameName: false,
  },
  {
    nameOne: "Janet",
    nameTwo: "Sibi",
    isTheSameName: false,
  },
  {
    nameOne: "Kylie",
    nameTwo: "Sibi",
    isTheSameName: false,
  },
  {
    nameOne: "Tinker",
    nameTwo: "Buckle",
    isTheSameName: false,
  },
  {
    nameOne: "Tinker",
    nameTwo: "Rey",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Cartledge",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Kahika",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Midson",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Ross",
    nameTwo: "Jan",
    isTheSameName: false,
  },
  {
    nameOne: "Were",
    nameTwo: "Taylor",
    isTheSameName: false,
  },
  {
    nameOne: "Rosemary",
    nameTwo: "Rosemaru",
    isTheSameName: true,
  },
  {
    nameOne: "Willis",
    nameTwo: "Steer",
    isTheSameName: false,
  },
  {
    nameOne: "Alam",
    nameTwo: "Alan",
    isTheSameName: true,
  },
  {
    nameOne: "Ribins",
    nameTwo: "Robins",
    isTheSameName: true,
  },
  {
    nameOne: "Allen",
    nameTwo: "Renee",
    isTheSameName: false,
  },
  {
    nameOne: "Aldous",
    nameTwo: "Y",
    isTheSameName: false,
  },
  {
    nameOne: "Naid00",
    nameTwo: "Naidoo",
    isTheSameName: true,
  },
  {
    nameOne: "Naid00",
    nameTwo: "Willcocks",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Kahika",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Midson",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Rachel",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Midson",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Leah",
    isTheSameName: false,
  },
  {
    nameOne: "Midson",
    nameTwo: "Vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "Midson",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Vanheel",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Guy",
    isTheSameName: false,
  },
  {
    nameOne: "Anna",
    nameTwo: "Peter",
    isTheSameName: false,
  },
  {
    nameOne: "Annie",
    nameTwo: "Corinne",
    isTheSameName: false,
  },
  {
    nameOne: "Stahorn",
    nameTwo: "Strahorn",
    isTheSameName: true,
  },
  {
    nameOne: "Ben",
    nameTwo: "Harrison",
    isTheSameName: false,
  },
  {
    nameOne: "Medwin",
    nameTwo: "Siawarta",
    isTheSameName: false,
  },
  {
    nameOne: "Bronte",
    nameTwo: "Sam",
    isTheSameName: false,
  },
  {
    nameOne: "Carly",
    nameTwo: "Joe",
    isTheSameName: false,
  },
  {
    nameOne: "Chris",
    nameTwo: "Riley",
    isTheSameName: false,
  },
  {
    nameOne: "Darrel",
    nameTwo: "Desley",
    isTheSameName: false,
  },
  {
    nameOne: "Edwards (wednesday 10th)",
    nameTwo: "Edwards",
    isTheSameName: true,
  },
  {
    nameOne: "Edwards (wednesday 10th)",
    nameTwo: "Jurgensen",
    isTheSameName: false,
  },
  {
    nameOne: "Deborah",
    nameTwo: "Hannah",
    isTheSameName: false,
  },
  {
    nameOne: "Deborah",
    nameTwo: "Lily",
    isTheSameName: false,
  },
  {
    nameOne: "Kahija",
    nameTwo: "Kahika",
    isTheSameName: true,
  },
  {
    nameOne: "Kahija",
    nameTwo: "Kiernan",
    isTheSameName: false,
  },
  {
    nameOne: "Kahija",
    nameTwo: "Sckroyd",
    isTheSameName: false,
  },
  {
    nameOne: "Sckroyd",
    nameTwo: "Kiernan",
    isTheSameName: false,
  },
  {
    nameOne: "Backlund",
    nameTwo: "Backlund.",
    isTheSameName: true,
  },
  {
    nameOne: "Cooke",
    nameTwo: "Backlund",
    isTheSameName: false,
  },
  {
    nameOne: "Chan",
    nameTwo: "Eugenie",
    isTheSameName: false,
  },
  {
    nameOne: "Eugenie",
    nameTwo: "Joel",
    isTheSameName: false,
  },
  {
    nameOne: "Felicia",
    nameTwo: "Vinay",
    isTheSameName: false,
  },
  {
    nameOne: "Giorgio",
    nameTwo: "Rebecca",
    isTheSameName: false,
  },
  {
    nameOne: "Glenda",
    nameTwo: "Mark",
    isTheSameName: false,
  },
  {
    nameOne: "Glenda",
    nameTwo: "Vanessa",
    isTheSameName: false,
  },
  {
    nameOne: "Edwards",
    nameTwo: "Redman",
    isTheSameName: false,
  },
  {
    nameOne: "Hannah",
    nameTwo: "Lily",
    isTheSameName: false,
  },
  {
    nameOne: "Ng",
    nameTwo: "Rapana-jenkins",
    isTheSameName: false,
  },
  {
    nameOne: "Izaac",
    nameTwo: "Kimberly",
    isTheSameName: false,
  },
  {
    nameOne: "Jen",
    nameTwo: "Jenny",
    isTheSameName: true,
  },
  {
    nameOne: "Jerry",
    nameTwo: "Jo",
    isTheSameName: false,
  },
  {
    nameOne: "Huang",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Joan",
    nameTwo: "Nathan",
    isTheSameName: false,
  },
  {
    nameOne: "Berrigan",
    nameTwo: "Crow",
    isTheSameName: false,
  },
  {
    nameOne: "Berrigan",
    nameTwo: "Secomb",
    isTheSameName: false,
  },
  {
    nameOne: "Berrigan",
    nameTwo: "Williams",
    isTheSameName: false,
  },
  {
    nameOne: "Crow",
    nameTwo: "Secomb",
    isTheSameName: false,
  },
  {
    nameOne: "Crow",
    nameTwo: "Williams",
    isTheSameName: false,
  },
  {
    nameOne: "Secomb",
    nameTwo: "Williams",
    isTheSameName: false,
  },
  {
    nameOne: "Tangira",
    nameTwo: "Scott",
    isTheSameName: false,
  },
  {
    nameOne: "Triggs",
    nameTwo: "Smith",
    isTheSameName: false,
  },
  {
    nameOne: "Katie",
    nameTwo: "Katoe",
    isTheSameName: true,
  },
  {
    nameOne: "Callcott",
    nameTwo: "Brinsden",
    isTheSameName: false,
  },
  {
    nameOne: "Callcott",
    nameTwo: "Gek",
    isTheSameName: false,
  },
  {
    nameOne: "Callcott",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Gek",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Kim",
    nameTwo: "Nick",
    isTheSameName: false,
  },
  {
    nameOne: "Leon",
    nameTwo: "Subria",
    isTheSameName: false,
  },
  {
    nameOne: "Liam",
    nameTwo: "Rachel",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn",
    nameTwo: "Sapuppo",
    isTheSameName: false,
  },
  {
    nameOne: "Lisa",
    nameTwo: "Simon",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Hawthorne",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Cawthorn",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Sapuppo",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Anderson",
    nameTwo: "Andeson",
    isTheSameName: true,
  },
  {
    nameOne: "Mark",
    nameTwo: "Vanessa",
    isTheSameName: false,
  },
  {
    nameOne: "De loryn",
    nameTwo: "Deoryn",
    isTheSameName: true,
  },
  {
    nameOne: "Devadas",
    nameTwo: "De loryn",
    isTheSameName: false,
  },
  {
    nameOne: "Matt",
    nameTwo: "Matthew",
    isTheSameName: true,
  },
  {
    nameOne: "Mick",
    nameTwo: "Ruth",
    isTheSameName: false,
  },
  {
    nameOne: "George",
    nameTwo: "Senat",
    isTheSameName: false,
  },
  {
    nameOne: "Chee",
    nameTwo: "Mclean",
    isTheSameName: false,
  },
  {
    nameOne: "Chee",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Mclean",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Khiroya",
    nameTwo: "Rough",
    isTheSameName: false,
  },
  {
    nameOne: "Khiroya",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Nick",
    nameTwo: "Sarah",
    isTheSameName: false,
  },
  {
    nameOne: "Rough",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Nick",
    nameTwo: "Vicky",
    isTheSameName: false,
  },
  {
    nameOne: "Mcglone",
    nameTwo: "Mcglones",
    isTheSameName: true,
  },
  {
    nameOne: "Wyborn",
    nameTwo: "Mcglone",
    isTheSameName: false,
  },
  {
    nameOne: "Hiron",
    nameTwo: "Alder",
    isTheSameName: false,
  },
  {
    nameOne: "Popie",
    nameTwo: "Russell",
    isTheSameName: false,
  },
  {
    nameOne: "Carteldge",
    nameTwo: "Cartledge",
    isTheSameName: true,
  },
  {
    nameOne: "Carteldge",
    nameTwo: "Tani",
    isTheSameName: false,
  },
  {
    nameOne: "Carteldge",
    nameTwo: "Woods",
    isTheSameName: false,
  },
  {
    nameOne: "Glover",
    nameTwo: "Carteldge",
    isTheSameName: false,
  },
  {
    nameOne: "Glover",
    nameTwo: "Tani",
    isTheSameName: false,
  },
  {
    nameOne: "Glover",
    nameTwo: "Woods",
    isTheSameName: false,
  },
  {
    nameOne: "Tani",
    nameTwo: "Woods",
    isTheSameName: false,
  },
  {
    nameOne: "Ralfi",
    nameTwo: "Ralfy",
    isTheSameName: true,
  },
  {
    nameOne: "Buckle",
    nameTwo: "Rey",
    isTheSameName: false,
  },
  {
    nameOne: "Ribyn",
    nameTwo: "Robyn",
    isTheSameName: true,
  },
  {
    nameOne: "Rigby",
    nameTwo: "Ortiz",
    isTheSameName: false,
  },
  {
    nameOne: "Agius",
    nameTwo: "Beasant",
    isTheSameName: false,
  },
  {
    nameOne: "Carrasco",
    nameTwo: "Dwyer",
    isTheSameName: false,
  },
  {
    nameOne: "Carrasco",
    nameTwo: "Fagan",
    isTheSameName: false,
  },
  {
    nameOne: "Carrasco",
    nameTwo: "Trial",
    isTheSameName: false,
  },
  {
    nameOne: "Dwyer",
    nameTwo: "Fagan",
    isTheSameName: false,
  },
  {
    nameOne: "Dwyer",
    nameTwo: "Trial",
    isTheSameName: false,
  },
  {
    nameOne: "Fagan",
    nameTwo: "Trial",
    isTheSameName: false,
  },
  {
    nameOne: "Perumal",
    nameTwo: "Reid",
    isTheSameName: false,
  },
  {
    nameOne: "Hinchlidde",
    nameTwo: "Hinchliffe",
    isTheSameName: true,
  },
  {
    nameOne: "Sarag",
    nameTwo: "Sarah",
    isTheSameName: true,
  },
  {
    nameOne: "Christie",
    nameTwo: "Khiroya",
    isTheSameName: false,
  },
  {
    nameOne: "Christie",
    nameTwo: "Sparey",
    isTheSameName: false,
  },
  {
    nameOne: "Khiroya",
    nameTwo: "Sparey",
    isTheSameName: false,
  },
  {
    nameOne: "Serg",
    nameTwo: "Serge",
    isTheSameName: true,
  },
  {
    nameOne: "Thomas",
    nameTwo: "Thomas mathew",
    isTheSameName: false,
  },
  {
    nameOne: "Tabby",
    nameTwo: "Tabitha",
    isTheSameName: true,
  },
  {
    nameOne: "Halkiotis",
    nameTwo: "Woolaston",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Meers",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: true,
  },
  {
    nameOne: "Christie",
    nameTwo: "Sibi thomas",
    isTheSameName: false,
  },
  {
    nameOne: "Colley",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Colley",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: false,
  },
  {
    nameOne: "Colley",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: false,
  },
  {
    nameOne: "Deanne",
    nameTwo: "Dave",
    isTheSameName: false,
  },
  {
    nameOne: "Deborah",
    nameTwo: "Dave",
    isTheSameName: false,
  },
  {
    nameOne: "Hannah",
    nameTwo: "Dave",
    isTheSameName: false,
  },
  {
    nameOne: "Lily",
    nameTwo: "Dave",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Felton",
    isTheSameName: true,
  },
  {
    nameOne: "Serg",
    nameTwo: "Sege",
    isTheSameName: true,
  },
  {
    nameOne: "Matt",
    nameTwo: "Mat",
    isTheSameName: true,
  },
  {
    nameOne: "Kahija",
    nameTwo: "Ackroyd",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Meers",
    isTheSameName: false,
  },
  {
    nameOne: "Khiroya",
    nameTwo: "Sibi thomas",
    isTheSameName: false,
  },
  {
    nameOne: "Kiernan",
    nameTwo: "Ackroyd",
    isTheSameName: false,
  },
  {
    nameOne: "Joey",
    nameTwo: "Vasiti",
    isTheSameName: false,
  },
  {
    nameOne: "Alam",
    nameTwo: "Akan",
    isTheSameName: true,
  },
  {
    nameOne: "Longmire",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: false,
  },
  {
    nameOne: "Longmire",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: false,
  },
  {
    nameOne: "Sckroyd",
    nameTwo: "Ackroyd",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 4th-8th november",
    nameTwo: "Cawthorn 7th-13th",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 4th-8th november",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 4th-8th november",
    nameTwo: "Cawthorn",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 4th-8th november",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn  30th-6thjuly",
    nameTwo: "Cawthorn 7th-13th",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn  30th-6thjuly",
    nameTwo: "Cawthorn",
    isTheSameName: true,
  },
  {
    nameOne: "Colley",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: false,
  },
  {
    nameOne: "Longmire",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 28th-1st november",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 28th-1st november",
    nameTwo: "Hawthorne",
    isTheSameName: true,
  },
  {
    nameOne: "",
    nameTwo: "",
    isTheSameName: false,
  },
  {
    nameOne: "janet and wayne",
    nameTwo: "kylie",
    isTheSameName: false,
  },
  {
    nameOne: "thomas",
    nameTwo: "thomas",
    isTheSameName: true,
  },
  {
    nameOne: "barry",
    nameTwo: "lee",
    isTheSameName: false,
  },
  {
    nameOne: "barry",
    nameTwo: "barry",
    isTheSameName: true,
  },
  {
    nameOne: "betham",
    nameTwo: "riordan",
    isTheSameName: false,
  },
  {
    nameOne: "brinaden",
    nameTwo: "gek",
    isTheSameName: false,
  },
  {
    nameOne: "brinaden",
    nameTwo: "callcott",
    isTheSameName: false,
  },
  {
    nameOne: "brinaden",
    nameTwo: "baxter",
    isTheSameName: false,
  },
  {
    nameOne: "brinsde",
    nameTwo: "gek",
    isTheSameName: false,
  },
  {
    nameOne: "brinsde",
    nameTwo: "callcott",
    isTheSameName: false,
  },
  {
    nameOne: "brinsde",
    nameTwo: "baxter",
    isTheSameName: false,
  },
  {
    nameOne: "brinsden",
    nameTwo: "baxter",
    isTheSameName: false,
  },
  {
    nameOne: "allan",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "brow",
    nameTwo: "sancho",
    isTheSameName: false,
  },
  {
    nameOne: "brown",
    nameTwo: "sancho",
    isTheSameName: false,
  },
  {
    nameOne: "bunn",
    nameTwo: "stanmore",
    isTheSameName: false,
  },
  {
    nameOne: "ban",
    nameTwo: "cherie",
    isTheSameName: false,
  },
  {
    nameOne: "peter",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "carole",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "katie",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "lorene",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "louis",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "renee",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "jono",
    nameTwo: "kmy",
    isTheSameName: false,
  },
  {
    nameOne: "jono",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "dunn",
    nameTwo: "sangster",
    isTheSameName: false,
  },
  {
    nameOne: "edwards",
    nameTwo: "iqbal",
    isTheSameName: false,
  },
  {
    nameOne: "emerton",
    nameTwo: "andrew",
    isTheSameName: false,
  },
  {
    nameOne: "kelly",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "manfred",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "celeste",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "feebrey",
    nameTwo: "riordan",
    isTheSameName: false,
  },
  {
    nameOne: "joel",
    nameTwo: "giorgio",
    isTheSameName: false,
  },
  {
    nameOne: "joel",
    nameTwo: "rebecca",
    isTheSameName: false,
  },
  {
    nameOne: "feebrey",
    nameTwo: "pauls",
    isTheSameName: false,
  },
  {
    nameOne: "joel",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "felton",
    nameTwo: "wyborn",
    isTheSameName: false,
  },
  {
    nameOne: "felton",
    nameTwo: "mcglone",
    isTheSameName: false,
  },
  {
    nameOne: "nick",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "field",
    nameTwo: "khiroya",
    isTheSameName: false,
  },
  {
    nameOne: "hilton & nicky",
    nameTwo: "liesl",
    isTheSameName: false,
  },
  {
    nameOne: "field",
    nameTwo: "todd",
    isTheSameName: false,
  },
  {
    nameOne: "field",
    nameTwo: "felton",
    isTheSameName: false,
  },
  {
    nameOne: "foster",
    nameTwo: "foster",
    isTheSameName: true,
  },
  {
    nameOne: "foster",
    nameTwo: "overton",
    isTheSameName: false,
  },
  {
    nameOne: "stephen",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "garratt",
    nameTwo: "garratt",
    isTheSameName: true,
  },
  {
    nameOne: "glass",
    nameTwo: "eberle",
    isTheSameName: false,
  },
  {
    nameOne: "goode",
    nameTwo: "shepherd",
    isTheSameName: false,
  },
  {
    nameOne: "serge",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "serge",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "hoare",
    nameTwo: "hoare",
    isTheSameName: true,
  },
  {
    nameOne: "iqbal",
    nameTwo: "glauser",
    isTheSameName: false,
  },
  {
    nameOne: "iqbal",
    nameTwo: "harman",
    isTheSameName: false,
  },
  {
    nameOne: "jarvis",
    nameTwo: "stahorn",
    isTheSameName: false,
  },
  {
    nameOne: "johnson",
    nameTwo: "sugunarajan",
    isTheSameName: false,
  },
  {
    nameOne: "johnson",
    nameTwo: "cunningham",
    isTheSameName: false,
  },
  {
    nameOne: "jones",
    nameTwo: "wood",
    isTheSameName: false,
  },
  {
    nameOne: "jones",
    nameTwo: "jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "debise",
    nameTwo: "lauren",
    isTheSameName: false,
  },
  {
    nameOne: "dk",
    nameTwo: "lauren",
    isTheSameName: false,
  },
  {
    nameOne: "dk",
    nameTwo: "leah",
    isTheSameName: false,
  },
  {
    nameOne: "keene",
    nameTwo: "cain",
    isTheSameName: false,
  },
  {
    nameOne: "paul",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "wendy",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "wendy",
    nameTwo: "elly",
    isTheSameName: false,
  },
  {
    nameOne: "kia",
    nameTwo: "chong",
    isTheSameName: false,
  },
  {
    nameOne: "knowles",
    nameTwo: "overton",
    isTheSameName: false,
  },
  {
    nameOne: "stephanie",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "knowles",
    nameTwo: "koslan-knowles",
    isTheSameName: true,
  },
  {
    nameOne: "lauren",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "sharon",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "sharon",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "kong",
    nameTwo: "tsang",
    isTheSameName: false,
  },
  {
    nameOne: "evelyn",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "evelyn",
    nameTwo: "katie",
    isTheSameName: false,
  },
  {
    nameOne: "kong",
    nameTwo: "brittain",
    isTheSameName: false,
  },
  {
    nameOne: "evelyn",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "koslan-knowles",
    nameTwo: "overton",
    isTheSameName: false,
  },
  {
    nameOne: "koslan-knowles",
    nameTwo: "koslan-knowles",
    isTheSameName: true,
  },
  {
    nameOne: "lahika",
    nameTwo: "sckroyd",
    isTheSameName: false,
  },
  {
    nameOne: "kieran",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "katie",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "leonard",
    nameTwo: "thomas",
    isTheSameName: false,
  },
  {
    nameOne: "leonard",
    nameTwo: "proud",
    isTheSameName: false,
  },
  {
    nameOne: "leonard",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "tracy",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "lindley",
    nameTwo: "shepherd",
    isTheSameName: false,
  },
  {
    nameOne: "livingstone",
    nameTwo: "hollands",
    isTheSameName: false,
  },
  {
    nameOne: "livingstone",
    nameTwo: "orr",
    isTheSameName: false,
  },
  {
    nameOne: "melinda",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "melinda",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "gl;enys",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "glenys",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "glwenys",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "glenyslocke",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "stanmore",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "rigby",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "loi",
    isTheSameName: true,
  },
  {
    nameOne: "helga",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "helga",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "lyon",
    nameTwo: "lyon",
    isTheSameName: true,
  },
  {
    nameOne: "lyndelle",
    nameTwo: "caitlin",
    isTheSameName: false,
  },
  {
    nameOne: "macdowall",
    nameTwo: "smart",
    isTheSameName: false,
  },
  {
    nameOne: "macdowall",
    nameTwo: "brittain",
    isTheSameName: false,
  },
  {
    nameOne: "lyndelle",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "olivia",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "mcelrea",
    nameTwo: "moss",
    isTheSameName: false,
  },
  {
    nameOne: "medwin",
    nameTwo: "whincop",
    isTheSameName: false,
  },
  {
    nameOne: "medwin",
    nameTwo: "tunha",
    isTheSameName: false,
  },
  {
    nameOne: "meers",
    nameTwo: "van heel",
    isTheSameName: false,
  },
  {
    nameOne: "meers",
    nameTwo: "warner",
    isTheSameName: false,
  },
  {
    nameOne: "meers",
    nameTwo: "vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "moore",
    nameTwo: "eberle",
    isTheSameName: false,
  },
  {
    nameOne: "lisa",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "lisa",
    nameTwo: "gregory",
    isTheSameName: false,
  },
  {
    nameOne: "alexandra",
    nameTwo: "amanda",
    isTheSameName: false,
  },
  {
    nameOne: "neville",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "ameshri",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "amy",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "riley",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "peter",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "eve",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "chris",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "joan",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "lisa",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "anna",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "kate",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "katie",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "kristen",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "adele",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "adam",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "renee",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "olivia",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "melinda",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "benjamin",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "sharon",
    isTheSameName: false,
  },
  {
    nameOne: "ng",
    nameTwo: "kellaway",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "julie",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "evelyn",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "jacinda",
    isTheSameName: false,
  },
  {
    nameOne: "ortiz",
    nameTwo: "stanmore",
    isTheSameName: false,
  },
  {
    nameOne: "ortiz",
    nameTwo: "loi",
    isTheSameName: false,
  },
  {
    nameOne: "ortiz",
    nameTwo: "o",
    isTheSameName: true,
  },
  {
    nameOne: "pauls",
    nameTwo: "riordan",
    isTheSameName: false,
  },
  {
    nameOne: "pauls",
    nameTwo: "chan",
    isTheSameName: false,
  },
  {
    nameOne: "portwin",
    nameTwo: "carrasco",
    isTheSameName: false,
  },
  {
    nameOne: "rapana",
    nameTwo: "renae",
    isTheSameName: false,
  },
  {
    nameOne: "renae",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "mike",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "saldana",
    nameTwo: "tsang",
    isTheSameName: false,
  },
  {
    nameOne: "sangster",
    nameTwo: "jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "benjamin",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "sangster",
    nameTwo: "burns",
    isTheSameName: false,
  },
  {
    nameOne: "jacinda",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "rocky",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "terry",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "shapcott",
    nameTwo: "damianopoulos",
    isTheSameName: false,
  },
  {
    nameOne: "shapcott",
    nameTwo: "triggs",
    isTheSameName: false,
  },
  {
    nameOne: "shapcott",
    nameTwo: "smith",
    isTheSameName: false,
  },
  {
    nameOne: "shapcott",
    nameTwo: "shapcott",
    isTheSameName: true,
  },
  {
    nameOne: "mark and karen",
    nameTwo: "mark & karen",
    isTheSameName: true,
  },
  {
    nameOne: "smith",
    nameTwo: "smith",
    isTheSameName: true,
  },
  {
    nameOne: "jason",
    nameTwo: "ric",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "vanessa",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "gavin",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "michelle",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "amy",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "hannah",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "cindy",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "laura",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "mark",
    isTheSameName: false,
  },
  {
    nameOne: "so",
    nameTwo: "so",
    isTheSameName: true,
  },
  {
    nameOne: "stanmore",
    nameTwo: "stanmore",
    isTheSameName: true,
  },
  {
    nameOne: "fay",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "stolar",
    nameTwo: "stolar",
    isTheSameName: true,
  },
  {
    nameOne: "sugunarajan",
    nameTwo: "edwards",
    isTheSameName: false,
  },
  {
    nameOne: "tailby",
    nameTwo: "mcghie",
    isTheSameName: false,
  },
  {
    nameOne: "wayne and janet",
    nameTwo: "kylie",
    isTheSameName: false,
  },
  {
    nameOne: "tinker",
    nameTwo: "wood",
    isTheSameName: false,
  },
  {
    nameOne: "tinker",
    nameTwo: "jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "junior",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "ross",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "adele",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "were",
    nameTwo: "webb",
    isTheSameName: false,
  },
  {
    nameOne: "were",
    nameTwo: "stanmore",
    isTheSameName: false,
  },
  {
    nameOne: "were",
    nameTwo: "were",
    isTheSameName: true,
  },
  {
    nameOne: "georgia",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "wood",
    nameTwo: "stahorn",
    isTheSameName: false,
  },
  {
    nameOne: "marty",
    nameTwo: "bec",
    isTheSameName: false,
  },
  {
    nameOne: "maureen",
    nameTwo: "bec",
    isTheSameName: false,
  },
  {
    nameOne: "martin",
    nameTwo: "bec",
    isTheSameName: false,
  },
  {
    nameOne: "maudie",
    nameTwo: "bec",
    isTheSameName: false,
  },
  {
    nameOne: "maudie",
    nameTwo: "marty",
    isTheSameName: false,
  },
  {
    nameOne: "benn",
    nameTwo: "benn",
    isTheSameName: true,
  },
  {
    nameOne: "smith mon)",
    nameTwo: "damianopoulos",
    isTheSameName: false,
  },
  {
    nameOne: "smith mon)",
    nameTwo: "triggs",
    isTheSameName: false,
  },
  {
    nameOne: "gee",
    nameTwo: "gee",
    isTheSameName: true,
  },
  {
    nameOne: "koblischk",
    nameTwo: "kahika",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "bunn",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "were",
    isTheSameName: false,
  },
];

export const orderByLastName = (users: UserData[]): UserData[] => {
  return users.sort((a, b) => {
    const lastNameA = a.lastName.toLowerCase();
    const lastNameB = b.lastName.toLowerCase();

    if (lastNameA < lastNameB) return -1;
    if (lastNameA > lastNameB) return 1;
    return 0;
  });
};

export const createNewUserId = (users: UserData[]): string => {
  const newUserId = Math.floor(Math.random() * 1000000000000000).toString();
  const isUsed = users.some((user) => user.userId === newUserId);
  if (isUsed) {
    return createNewUserId(users);
  } else {
    return newUserId;
  }
};

export const eraseSpacesInUsers = (users: UserData[]): UserData[] => {
  const updatedUsers: UserData[] = [];

  users.forEach((user) => {
    const updatedUser: UserData = {
      ...user,
      firstName: user.firstName.trim(),
      lastName: user.lastName.trim(),
      email: user.email.map((email) => email.trim()),
    };

    updatedUsers.push(updatedUser);
  });

  console.log("Cleaned up spaces in UserData");
  return updatedUsers;
};

export const cleanDatabaseOfEmptyEmailFields = (
  users: UserData[]
): UserData[] => {
  const updatedUsers: UserData[] = [];

  users.forEach((user) => {
    const updatedUser: UserData = {
      ...user,
      email: user.email.filter((email) => email !== ""),
    };

    updatedUsers.push(updatedUser);
  });

  console.log("Cleaned up empty email fields in UserData");
  return updatedUsers;
};

export const listUsersWithDatesInTheirNames = (
  users: UserData[]
): UserData[] => {
  const listOfUsers: UserData[] = [];

  users.forEach((user) => {
    if (
      user.firstName.includes("(") ||
      user.firstName.includes(")") ||
      user.lastName.includes("(") ||
      user.lastName.includes(")")
    ) {
      listOfUsers.push(user);
    }
  });

  console.log(listOfUsers);
  return listOfUsers;
};

export const cleanupSameIdDuplicates = (users: UserData[]): UserData[] => {
  const newUsers = users;

  newUsers.forEach((userChecked) => {
    newUsers.forEach((userCheckedAgainst) => {
      if (
        newUsers.indexOf(userChecked) !==
          newUsers.indexOf(userCheckedAgainst) &&
        userChecked.userId === userCheckedAgainst.userId
      ) {
        // Combine emails of these users
        let combinedEmails: string[] = [
          ...userChecked.email,
          ...userCheckedAgainst.email,
        ];
        // Remove duplicate emails from combinedEmails
        combinedEmails = combinedEmails.filter(
          (email, index) => combinedEmails.indexOf(email) === index
        );
        // change email value of userChecked
        userChecked.email = combinedEmails;
        newUsers.splice(newUsers.indexOf(userCheckedAgainst), 1);
        console.log(
          `Deleted Duplicate userId ${userChecked.userId} and ${userCheckedAgainst.userId}`
        );
      }
    });
  });
  return newUsers;
};

export const cleanupSameNamesDuplicates = (users: UserData[]): UserData[] => {
  const newUsers = users;

  newUsers.forEach((userChecked) => {
    newUsers.forEach((userCheckedAgainst) => {
      if (
        newUsers.indexOf(userChecked) !==
          newUsers.indexOf(userCheckedAgainst) &&
        userChecked.firstName === userCheckedAgainst.firstName &&
        userChecked.lastName === userCheckedAgainst.lastName
      ) {
        // Combine emails of these newUsers
        let combinedEmails: string[] = [
          ...userChecked.email,
          ...userCheckedAgainst.email,
        ];
        // Remove duplicate emails from combinedEmails
        combinedEmails = combinedEmails.filter(
          (email, index) => combinedEmails.indexOf(email) === index
        );
        // change email value of userChecked
        userChecked.email = combinedEmails;
        newUsers.splice(newUsers.indexOf(userCheckedAgainst), 1);
      }
      console.log(
        `Cleaned same Name users ${userChecked.userId} and ${userCheckedAgainst.userId}`
      );
    });
  });
  return newUsers;
};

export const cleanupSameFirstOrLastNameDuplicates = (
  users: UserData[]
): UserData[] => {
  const newUsers = users;

  newUsers.forEach((userChecked) => {
    console.log(`Checking User ${newUsers.indexOf(userChecked)}`);
    newUsers.forEach((userCheckedAgainst) => {
      if (
        newUsers.indexOf(userChecked) !==
          newUsers.indexOf(userCheckedAgainst) &&
        (userChecked.firstName === userCheckedAgainst.firstName ||
          userChecked.lastName === userCheckedAgainst.lastName)
      ) {
        let nameOne = "";
        let nameTwo = "";
        if (userChecked.firstName === userCheckedAgainst.firstName) {
          nameOne = userChecked.lastName;
          nameTwo = userCheckedAgainst.lastName;
        } else if (userChecked.lastName === userCheckedAgainst.lastName) {
          nameOne = userChecked.firstName;
          nameTwo = userCheckedAgainst.firstName;
        }

        const existingCombination = alreadyCheckedCombinations.find(
          (combination) =>
            (combination.nameOne === nameOne &&
              combination.nameTwo === nameTwo) ||
            (combination.nameOne === nameTwo && combination.nameTwo === nameOne)
        );
        let whatToDo = "nothing";

        if (existingCombination !== undefined) {
          if (existingCombination.isTheSameName === true) {
            whatToDo = "merge";
          } else if (existingCombination.isTheSameName === false) {
            whatToDo = "no merge";
          }
        } else {
          const sameFirstNameConfirmation = window.confirm(
            `Are ${nameOne} ${nameTwo} the same?`
          );
          const checkedCombinaison = {
            nameOne: nameOne,
            nameTwo: nameTwo,
            isTheSameName: sameFirstNameConfirmation,
          };
          alreadyCheckedCombinations.push(checkedCombinaison);
          if (sameFirstNameConfirmation) {
            whatToDo = "merge";
          } else {
            whatToDo = "no merge";
          }
        }
        if (whatToDo === "merge") {
          // Combine emails of these newUsers
          let combinedEmails: string[] = [
            ...userChecked.email,
            ...userCheckedAgainst.email,
          ];
          // Remove duplicate emails from combinedEmails
          combinedEmails = combinedEmails.filter(
            (email, index) => combinedEmails.indexOf(email) === index
          );
          // change email value of userChecked
          userChecked.email = combinedEmails;
          console.log(
            `Cleaned same Name users ${userChecked.userId} and ${userCheckedAgainst.userId}`
          );
          newUsers.splice(newUsers.indexOf(userCheckedAgainst), 1);
        }
      }
    });
  });
  console.log("User Database After cleaned same First or Last Name users");
  console.log(newUsers);
  console.log("New Checked Combinations");
  console.log(alreadyCheckedCombinations);
  return newUsers;
};

export const cleanupDatabase = (users: UserData[]) => {
  console.log("User Database Before Cleanup");
  console.log(users);
  const cleanupSpaces = eraseSpacesInUsers(users);
  const cleanupEmptyEmails = cleanDatabaseOfEmptyEmailFields(cleanupSpaces);
  const cleanupSameIDDup = cleanupSameIdDuplicates(cleanupEmptyEmails);
  const cleanupSameNamesDup = cleanupSameIdDuplicates(cleanupSameIDDup);
  const cleanupSameFirstOrLastNameDup =
    cleanupSameFirstOrLastNameDuplicates(cleanupSameNamesDup);
  const reorderedDatabase = orderByLastName(cleanupSameFirstOrLastNameDup);
  console.log("User Database After Cleanup");
  console.log(reorderedDatabase);
  return reorderedDatabase;
};

export const deleteRoleFromUser = (
  user: UserData,
  roleToDelete: UserRole
): UserData => {
  const updatedUser: UserData = {
    ...user,
    PCRoles: user.PCRoles.filter((role) => role !== roleToDelete),
  };
  return updatedUser;
};

export function compareDepthLevelOfNodes(
  teamIdNode1: OrgTreeItem,
  teamIdNode2: OrgTreeItem
): number {
  const teamIdNode1Array = teamIdNode1.key.split("-");
  const teamIdNode2Array = teamIdNode2.key.split("-");

  if (teamIdNode1Array.length > teamIdNode2Array.length) {
    return 1;
  } else if (teamIdNode1Array.length < teamIdNode2Array.length) {
    return -1;
  } else {
    return 0;
  }
}

export const addRoleToUser = (
  user: UserData,
  roleToAdd: UserRole
): UserData => {
  const updatedUser: UserData = {
    ...user,
    PCRoles: [...user.PCRoles, roleToAdd],
  };

  //re-order the roles array by level of access
  const roleOrder = [
    "volunteer",
    "churchStaff",
    "pastoralCare",
    "oversight",
    "admin",
  ];
  updatedUser.PCRoles.sort(
    (a, b) => roleOrder.indexOf(a.role) - roleOrder.indexOf(b.role)
  );

  return updatedUser;
};

export const checkExistingUserWithFirebaseUidAndEmail = (
  firebaseUid: string,
  firebaseEmail: string | null,
  firebaseDisplayName: string | null,
  users: UserData[]
): UserData | undefined => {
  const foundUserUid = users.find((user) =>
    user.firebaseUid?.some((uid) => uid === firebaseUid)
  );
  const fondUserEmail = users.find((user) =>
    user.email.some((userEmail) => userEmail === firebaseEmail)
  );
  const foundMatchingNames = users.find((user) => {
    return (
      user.firstName.toLowerCase() ===
        firebaseDisplayName?.toLowerCase().split(" ")[0] &&
      user.lastName.toLowerCase() ===
        firebaseDisplayName?.toLowerCase().split(" ")[1]
    );
  });
  if (foundUserUid) {
    return foundUserUid;
  } else if (fondUserEmail) {
    fondUserEmail.firebaseUid
      ? fondUserEmail.firebaseUid.push(firebaseUid)
      : (fondUserEmail.firebaseUid = [firebaseUid]);
    uploadUser(fondUserEmail);
    return fondUserEmail;
  } else if (foundMatchingNames) {
    foundMatchingNames.firebaseUid
      ? foundMatchingNames.firebaseUid.push(firebaseUid)
      : (foundMatchingNames.firebaseUid = [firebaseUid]);
    uploadUser(foundMatchingNames);
  }
};

export const searchUser = (
  userToCheckEmail: string,
  userToCheckFirstName: string,
  userToCheckLastName: string,
  users: UserData[]
): UserData | undefined => {
  const foundUser = users.find((user) => {
    //check basic email match
    if (
      userToCheckEmail &&
      user.email.some(
        (email) =>
          email.toLowerCase().includes(userToCheckEmail.toLowerCase().trim()) ||
          userToCheckEmail.toLowerCase().includes(email.toLowerCase().trim())
      )
    ) {
      return true;
    }
    //check basic match firstName === firstName and lastName === lastName
    if (
      (user.firstName
        .toLowerCase()
        .trim()
        .includes(userToCheckFirstName.toLowerCase().trim()) ||
        userToCheckFirstName
          .toLowerCase()
          .trim()
          .includes(user.firstName.toLowerCase().trim())) &&
      (user.lastName
        .toLowerCase()
        .trim()
        .includes(userToCheckLastName.toLowerCase().trim()) ||
        userToCheckLastName
          .toLowerCase()
          .trim()
          .includes(user.lastName.toLowerCase().trim()))
    ) {
      return true;
    }
    //if One of the names are the same but the other one isn't check for typos
    let nameOne = "";
    let nameTwo = "";
    if (
      userToCheckFirstName
        .toLocaleLowerCase()
        .trim()
        .includes(user.firstName.toLocaleLowerCase().trim()) ||
      user.firstName
        .toLocaleLowerCase()
        .trim()
        .includes(userToCheckFirstName.toLocaleLowerCase().trim())
    ) {
      nameOne = userToCheckLastName.toLocaleLowerCase().trim();
      nameTwo = user.lastName.toLocaleLowerCase().trim();
    } else if (
      userToCheckLastName
        .toLocaleLowerCase()
        .trim()
        .includes(user.lastName.toLocaleLowerCase().trim()) ||
      user.lastName
        .toLocaleLowerCase()
        .trim()
        .includes(userToCheckLastName.toLocaleLowerCase().trim())
    ) {
      nameOne = userToCheckFirstName.toLocaleLowerCase().trim();
      nameTwo = user.firstName.toLocaleLowerCase().trim();
    }

    const existingCombination = alreadyCheckedCombinations.find(
      (combination) =>
        (combination.nameOne.toLocaleLowerCase().trim() === nameOne &&
          combination.nameTwo.toLocaleLowerCase().trim() === nameTwo) ||
        (combination.nameOne.toLocaleLowerCase().trim() === nameTwo &&
          combination.nameTwo.toLocaleLowerCase().trim() === nameOne)
    );
    let whatToDo = "nothing";

    if (existingCombination !== undefined) {
      if (existingCombination.isTheSameName === true) {
        whatToDo = "userFound";
      } else if (existingCombination.isTheSameName === false) {
        whatToDo = "no merge";
      }
    }
    if (whatToDo === "userFound") {
      return true;
    }
  });

  if (foundUser) {
    /* console.log(`Existing user is ${foundUser.firstName} ${foundUser.lastName}}`); */
    return foundUser;
  } else {
    return undefined;
  }
};

export const checkForUserDataImport = (
  userToCheckEmail: string,
  userToCheckFirstName: string,
  userToCheckLastName: string,
  users: UserData[]
): UserData | undefined => {
  const foundUser = users.find((user) => {
    const userCopy = { ...user };

    //check for empty user
    if (!userToCheckFirstName || !userToCheckFirstName) {
      return false;
    }
    //check basic email match
    if (
      userToCheckEmail &&
      userCopy.email.some(
        (email) =>
          email
            .toLowerCase()
            .trim()
            .includes(userToCheckEmail.toLowerCase().trim()) ||
          userToCheckEmail
            .toLowerCase()
            .trim()
            .includes(email.toLowerCase().trim())
      )
    ) {
      return true;
    }
    //check basic match firstName === firstName and lastName === lastName
    if (
      (userCopy.firstName
        .toLowerCase()
        .trim()
        .includes(userToCheckFirstName.toLowerCase().trim()) ||
        userToCheckFirstName
          .toLowerCase()
          .trim()
          .includes(userCopy.firstName.toLowerCase().trim())) &&
      (userCopy.lastName
        .toLowerCase()
        .trim()
        .includes(userToCheckLastName.toLowerCase().trim()) ||
        userToCheckLastName
          .toLowerCase()
          .trim()
          .includes(userCopy.lastName.toLowerCase().trim()))
    ) {
      /* console.log("user first name: ", user.firstName, "user last name: ", user.lastName)
      console.log("userToCheckFirstName: ", userToCheckFirstName, "userToCheckLastName: ", userToCheckLastName)
      return true; */
    }
    //if One of the names are the same but the other one isn't check for typos
    let nameOne = "";
    let nameTwo = "";
    if (
      userToCheckFirstName
        .toLocaleLowerCase()
        .trim()
        .includes(userCopy.firstName.toLocaleLowerCase().trim()) ||
      userCopy.firstName
        .toLocaleLowerCase()
        .trim()
        .includes(userToCheckFirstName.toLocaleLowerCase().trim())
    ) {
      nameOne = userToCheckLastName.toLocaleLowerCase().trim();
      nameTwo = userCopy.lastName.toLocaleLowerCase().trim();
    } else if (
      userToCheckLastName
        .toLocaleLowerCase()
        .trim()
        .includes(userCopy.lastName.toLocaleLowerCase().trim()) ||
      userCopy.lastName
        .toLocaleLowerCase()
        .trim()
        .includes(userToCheckLastName.toLocaleLowerCase().trim())
    ) {
      nameOne = userToCheckFirstName.toLocaleLowerCase().trim();
      nameTwo = userCopy.firstName.toLocaleLowerCase().trim();
    }

    const existingCombination = alreadyCheckedCombinations.find(
      (combination) =>
        (combination.nameOne.toLocaleLowerCase().trim() === nameOne &&
          combination.nameTwo.toLocaleLowerCase().trim() === nameTwo) ||
        (combination.nameOne.toLocaleLowerCase().trim() === nameTwo &&
          combination.nameTwo.toLocaleLowerCase().trim() === nameOne)
    );
    let whatToDo = "nothing";

    if (existingCombination !== undefined) {
      if (existingCombination.isTheSameName === true) {
        whatToDo = "userFound";
      } else if (existingCombination.isTheSameName === false) {
        whatToDo = "no merge";
      }
    } else {
      const sameFirstNameConfirmation = window.confirm(
        `Are ${nameOne} and ${nameTwo} the same?`
      );
      const checkedCombinaison = {
        nameOne: nameOne,
        nameTwo: nameTwo,
        isTheSameName: sameFirstNameConfirmation,
      };
      alreadyCheckedCombinations.push(checkedCombinaison);
      if (sameFirstNameConfirmation) {
        whatToDo = "userFound";
      } else {
        whatToDo = "no merge";
      }
    }
    if (whatToDo === "userFound") {
      return true;
    }
  });

  if (foundUser) {
    /* console.log(`Existing user is ${foundUser.firstName} ${foundUser.lastName}}`); */
    return foundUser;
  } else {
    return undefined;
  }
};
